import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { EvaluationComparison } from '../../models/evaluation-comparison';
import { AiScrubScope } from '../../models';

export const getEvaluationComparison: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
  scope?: AiScrubScope,
  countryId?: number,
) => Promise<EvaluationComparison[]> = (fetchContext, awardId, accessToken, scope = 'awards', countryId) => {
  const query = countryId != null ? `?${new URLSearchParams({ countryId: String(countryId) }).toString()}` : '';
  return fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/evaluation-comparison${query}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<EvaluationComparison[]>(fetchContext.errorStore, response, 'get evaluation comparison'));
};
